module.exports = __webpack_public_path__ + "static/media/875eca27.jpg";